import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/i18n/LanguageProvider";
import Layout from "@/components/layout/Layout";
import { SITE } from "@/config/site";
import { pagePath, entityPath, articlePath } from "@/config/pages";
import { TREATMENTS } from "@/data/treatments";
import { LOCATIONS } from "@/data/locations";
import { ARTICLES } from "@/data/articles";

import Home from "@/pages/Home";
import TreatmentsIndex from "@/pages/TreatmentsIndex";
import TreatmentPage from "@/pages/TreatmentPage";
import LocationPage from "@/pages/LocationPage";
import DentalTourism from "@/pages/DentalTourism";
import BlogHub from "@/pages/BlogHub";
import ArticlePage from "@/pages/ArticlePage";
import Prices from "@/pages/Prices";
import Clinics from "@/pages/Clinics";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import BeforeAfter from "@/pages/BeforeAfter";
import StaticPage from "@/pages/StaticPage";
import NotFound from "@/pages/NotFound";

// Static page keys rendered by the generic StaticPage template.
const STATIC_TEMPLATE_KEYS = [
  "patientGuide",
  "about",
  "howWeSelect",
  "editorial",
  "medicalReview",
  "disclaimer",
  "privacy",
  "terms",
];

// Dedicated components mapped to page keys.
const DEDICATED = {
  home: () => <Home />,
  dentalTreatment: () => <TreatmentsIndex />,
  prices: () => <Prices />,
  clinics: () => <Clinics />,
  dentalTourism: () => <DentalTourism />,
  blog: () => <BlogHub />,
  faq: () => <Faq />,
  beforeAfter: () => <BeforeAfter />,
  contact: () => <Contact />,
};

function buildRoutes() {
  const routes = [];
  SITE.languages.forEach((lang) => {
    // Dedicated pages
    Object.entries(DEDICATED).forEach(([key, render]) => {
      routes.push({ path: pagePath(key, lang), element: render() });
    });
    // Static template pages
    STATIC_TEMPLATE_KEYS.forEach((key) => {
      routes.push({ path: pagePath(key, lang), element: <StaticPage pageKey={key} /> });
    });
    // Treatments
    TREATMENTS.forEach((tr) => {
      routes.push({ path: entityPath(null, tr.slug, lang), element: <TreatmentPage treatmentKey={tr.key} /> });
    });
    // Locations
    LOCATIONS.forEach((lo) => {
      routes.push({ path: entityPath(null, lo.slug, lang), element: <LocationPage locationKey={lo.key} /> });
    });
    // Articles
    ARTICLES.forEach((ar) => {
      routes.push({ path: articlePath(ar.slug, lang), element: <ArticlePage articleKey={ar.key} /> });
    });
  });
  return routes;
}

const ROUTES = buildRoutes();

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <Layout>
            <Routes>
              {ROUTES.map((r) => (
                <Route key={r.path} path={r.path} element={r.element} />
              ))}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
